import React from "react";
import Questions_Table from "../../utilities/tableQuestionnaire/questionaire_score";
import  {Container}  from "react-bootstrap";
import mmse from "./mmse.json";

class MMSE extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mmseScore: 0,
            responses: props.data || {},
            hasInvalidInputs: false
        };
        this.questionsTableRef = React.createRef();
    }

    // Handler for answer changes
    // handleAnswerChange = (event) => {
    //     const { name, value, isValid } = event.target;
    //     this.setState(prevState => ({
    //         ...prevState,
    //         responses: {
    //             ...prevState.responses,
    //             [name]: value
    //         }
    //     }));
    //     // If parent component needs the data
    //     if (this.props.onChange) {
    //         this.props.onChange({
    //             ...this.state.responses,
    //             [name]: value
    //         });
    //     }
    // };
    handler = (state) => {
        this.props.handler('mmse',state)
    }
    // Handler for score updates
    handleScoreChange = (scoreValue) => {
        this.setState(prevState => ({
            mmseScore: prevState.mmseScore + scoreValue
        }));

        // If parent component needs the score
        if (this.props.onScoreChange) {
            this.props.onScoreChange(this.state.mmseScore + scoreValue);
        }
    };

    // Get calculated score (or null if invalid inputs exist)
    getCalculatedScore = () => {
        if (this.questionsTableRef.current) {
            const totalScore = this.questionsTableRef.current.getTotalScore();
            return totalScore !== null ? totalScore : "Invalid";
        }
        return this.state.mmseScore;
    };

    render() {
        // MMSE Questions with the new JSON format


        // Calculate current score
        const currentScore = this.getCalculatedScore();

        return (
            <Container>
                <h1>Mini Mental State Examination</h1>
                {/*<p>Total Points: {currentScore !== "Invalid" ? currentScore + "/30" : "Invalid inputs present"}</p>*/}

                <Questions_Table
                    questions={mmse}
                    handler={this.handler}
                    fieldName="mmseResponses"
                    score={true}
                    scoreFunc={this.handleScoreChange}
                    data={this.props.data || null}
                    disabled={this.props.disabled || false}
                />

                {/*{currentScore !== "Invalid" && (*/}
                {/*    <div className="mt-4">*/}
                {/*        <h4>Interpretation:</h4>*/}
                {/*        {currentScore >= 24 ? (*/}
                {/*            <p>Score {currentScore}/30: No cognitive impairment</p>*/}
                {/*        ) : currentScore >= 19 ? (*/}
                {/*            <p>Score {currentScore}/30: Mild cognitive impairment</p>*/}
                {/*        ) : currentScore >= 10 ? (*/}
                {/*            <p>Score {currentScore}/30: Moderate cognitive impairment</p>*/}
                {/*        ) : (*/}
                {/*            <p>Score {currentScore}/30: Severe cognitive impairment</p>*/}
                {/*        )}*/}
                {/*    </div>*/}
                {/*)}*/}
            </Container>
        );
    }
}

export default MMSE;